function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import noScroll from 'no-scroll';
import { getProp, noop } from '../lib/utils';
import { hidden } from '../lib/styles';
import OverlayProvider from './Overlay';
import { withUniqueId } from './UniqueId';
var ModalOverlay = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(ModalOverlay, _React$PureComponent);
  function ModalOverlay() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _defineProperty(_assertThisInitialized(_this), "modals", _this.props.initialModalId ? [_this.props.initialModalId] : []);
    _defineProperty(_assertThisInitialized(_this), "scrollFreezes", []);
    _defineProperty(_assertThisInitialized(_this), "state", {
      currentModalId: getProp(_this.props.initialModalId, '')
    });
    _defineProperty(_assertThisInitialized(_this), "value", {
      closeById: function closeById(modalId) {
        var index = _this.modals.indexOf(modalId);
        if (index !== -1) {
          _this.modals.splice(index, 1);
          _this.props.onClose(modalId);
          _this.setState({
            currentModalId: _this.modals.length ? _this.modals[_this.modals.length - 1] : ''
          });
          var freezeIndex = _this.scrollFreezes.indexOf(modalId);
          if (freezeIndex !== -1) {
            _this.scrollFreezes.splice(freezeIndex, 1);
            if (_this.scrollFreezes.length === 0) {
              noScroll.off();
            }
          }
        }
      },
      getIndexById: function getIndexById(modalId) {
        return _this.modals.indexOf(modalId);
      },
      isOpenById: function isOpenById(modalId) {
        return _this.modals.includes(modalId);
      },
      openById: function openById(modalId, freezeScroll) {
        var index = _this.modals.indexOf(modalId);
        if (index === -1) {
          _this.modals.push(modalId);
          _this.props.onOpen(modalId);
          if (freezeScroll) {
            if (_this.scrollFreezes.length === 0) {
              noScroll.on();
            }
            _this.scrollFreezes.push(modalId);
          }
        }
        if (_this.state.currentModalId !== modalId) {
          _this.setState({
            currentModalId: modalId
          });
        }
      }
    });
    return _this;
  }
  var _proto = ModalOverlay.prototype;
  _proto.render = function render() {
    var currentModalId = this.state.currentModalId;
    var id = this.props.id;
    var name = this.props.name === null ? null : getProp(this.props.name, id);
    /**
     * Change object reference only if there are actual changes.
     */
    if (this.value.currentModalId !== currentModalId || this.value.overlayId !== id || this.value.overlayName !== name) {
      this.value = _objectSpread({}, this.value, {
        currentModalId: currentModalId,
        overlayId: id,
        overlayName: name
      });
    }
    return React.createElement(OverlayProvider, {
      value: this.value
    }, React.createElement("input", {
      checked: currentModalId !== '',
      id: id,
      name: name,
      onChange: this.props.onChange,
      style: hidden,
      type: "checkbox",
      value: currentModalId
    }), typeof this.props.children === 'function' ? this.props.children(_objectSpread({}, this.value)) : this.props.children);
  };
  return ModalOverlay;
}(React.PureComponent);
_defineProperty(ModalOverlay, "defaultProps", {
  onClose: noop,
  onOpen: noop
});
process.env.NODE_ENV !== "production" ? ModalOverlay.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  id: PropTypes.string,
  initialModalId: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  onOpen: PropTypes.func
} : void 0;
export default withUniqueId({
  identifier: 'modal-overlay'
})(ModalOverlay);